import { Box, Typography } from "@mui/material";
import useColors from "../../api/hooks/useColors";
import {
  getFeasibilityColor,
  getJiraStatusColor,
  getPriorityColor,
  getStatusColor,
} from "../../scenes/posture/controls/components/EntitiesSection/utils";

const CircleOption = ({ label, type }) => {
  const colors = useColors();
  let sx;
  switch (type) {
    case "status":
      sx = { backgroundColor: getStatusColor(label, colors) };
      break;
    case "priority":
      const priorityColor = getPriorityColor(label, colors);
      sx = {
        backgroundColor: priorityColor.background,
        border: `1px solid ${priorityColor.border}`,
      };
      break;
    case "feasibility":
    case "impact":
      const feasibilityColor = getFeasibilityColor(label, colors);
      sx = {
        backgroundColor: feasibilityColor.background,
        border: `1px solid ${feasibilityColor.border}`,
      };
      break;
    case "jiraStatus":
      const jiraStatusColor = getJiraStatusColor(label, colors);
      sx = {
        backgroundColor: jiraStatusColor,
      };
      break;
    default:
      break;
  }

  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      alignContent={"baseline"}
      gap={1}
    >
      {sx && (
        <Box
          sx={{
            ...sx,
            width: "10px",
            height: "10px",
            borderRadius: "50%",
          }}
        />
      )}
      <Typography variant="caption" color={colors.text_primary}>
        {label}
      </Typography>
    </Box>
  );
};

export default CircleOption;
